import React from 'react';
import { useTranslate } from 'react-admin';
import { Chip, CircularProgress } from '@mui/material';
import type { IOcrTestRun } from '@/types';

/** A running run is the exception worth a chip; a finished one reads in words. */
export const RunState: React.FC<{ run: IOcrTestRun }> = ({ run }) => {
  const t = useTranslate();
  if (run.finishedAt) return <>{t('screens.ocrTesting.completed')}</>;
  return (
    <Chip icon={<CircularProgress size={12} color="inherit" />} label={t('screens.ocrTesting.running')} color="info" size="small" />
  );
};
